import {Component, OnDestroy} from '@angular/core';
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";
import {Subject, takeUntil} from "rxjs";
import {screenType} from "../../../core/shared.selectors";
import {Router} from "@angular/router";
import {UserIdleService} from "../../../services/user-idle.service";
import {CommonService} from "../../../services/common.service";
import {
  LogoutWarningComponent
} from "../../logout-warning/logout-warning.component";

@Component({
  selector: 'app-authenticated-wrapper',
  templateUrl: './authenticated-wrapper.component.html',
  styleUrls: ['./authenticated-wrapper.component.css']
})
export class AuthenticatedWrapperComponent implements OnDestroy {
  opened = false;
  screenType: string = '';
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private userIdleService: UserIdleService,
    private commonService: CommonService,
  ) {
    userIdleService.idle.subscribe(() => {
      if (this.commonService.isAuthenticated()) {
        this.commonService.openDialog({
          data: {
            component: LogoutWarningComponent,
            panelWidth: 20,
            disableClose: true
          }
        })
      }
    });
  }

  ngOnInit() {
    this.store.select(screenType).pipe(takeUntil(this.onDestroy))
      .subscribe(screenType => {
        this.screenType = screenType;

        if (screenType !== 'mobile') {
          this.opened = true;
        } else {
          this.opened = false;
        }
      })
  }

  goHome() {
    this.router.navigate(['/']);
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
